import { Link, NavLink } from "react-router-dom";
import { ASSETS } from "../lib/assets";

const navItems = [
  { to: "/", label: "Inicio" },
  { to: "/noticias", label: "Noticias" },
  { to: "/eventos", label: "Eventos" },
  { to: "/calendario", label: "Calendario" },
  { to: "/galeria", label: "Galería" },
  { to: "/radio", label: "Radio" },
  { to: "/nosotros", label: "Nosotros" },
];

export default function Navbar() {
  return (
    <nav
      data-testid="main-nav"
      className="glass-nav fixed top-0 inset-x-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group shrink-0"
        >
          <div className="w-10 h-10 rounded-full overflow-hidden ring-2 ring-[color:var(--inv-primary)]/30">
            <img
              src={ASSETS.churchLogo}
              alt="Nueva Vida Internacional"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-heading font-semibold text-[14px] tracking-tight">
              Nueva Vida Internacional
            </div>
            <div className="text-[10px] text-[color:var(--inv-text-muted)] uppercase tracking-wider">
              Scranton, PA
            </div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-0.5">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm rounded-full transition-colors ${
                  isActive
                    ? "bg-[color:var(--inv-secondary)] text-white"
                    : "text-[color:var(--inv-text)] hover:bg-[color:var(--inv-surface-alt)]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <Link
          to="/admin"
          data-testid="nav-admin-link"
          className="btn-pill btn-pill-primary text-sm py-2"
        >
          Admin
        </Link>
      </div>
    </nav>
  );
}
